import floatButton from './floatButton.vue'
export default floatButton